const analyticsPrototype = {
    /**
     * Is analytics tracking enabled
     */
    _isActive: false,
    /**
     * Is in debug mode (emulation mode)
     * in debug mode - events WILL NOT be sent to the service
     */
    _isDebugMode: false,
    /**
     * API key
     *
     * @private
     */
    _apiKey: null,
    /**
     * Current user
     * @private
     */
    _user: null,
    /**
     * Users organization
     * @private
     */
    _organization: null,
    /**
     * We dont want to request js library twice
     * @private
     */
    _isAnalyticEngineRequested: false,
    /**
     * Flag - is library loaded
     * @private
     */
    _isAnalyticEngineSet: false,
    /**
     * Analytics library
     * @private
     */
    _analyticEngine: null,
    /**
     * If analytics library is not loaded, but action trigered - push events to queue
     * @type {[]}
     * @private
     */
    _analyticsQueue: [],
    /**
     * Flag - is auto page tracking enabled
     * @private
     */
    _isPageTrackingEnabled: true,
    /**
     * Flag - is NavLink tracking enabled
     * @private
     */
    _isNavLinkClickEnabled: true,

    /**
     * @param apiKey
     * @param user
     * @param isActive
     * @param isDebugMode
     * @param isPageTrackingEnabled
     * @param isNavLinkClickEnabled
     */
    bootstrap(apiKey, user = null, isActive = false, isDebugMode = false, isPageTrackingEnabled = true, isNavLinkClickEnabled = true) {
        this._apiKey = apiKey;
        this._isActive = isActive;
        this._isDebugMode = isDebugMode;
        this.setPageTrackingState(isPageTrackingEnabled);
        this.setNavLinkClickState(isNavLinkClickEnabled);

        if (!this._isActive) {
            return;
        } else if (this._isDebugMode) {
            console.info('!!! Analytics is an debug mode. Any requests will not be sent to the service !!!');

            this._trackPageVisitListener();
            this._trackingNavLinkClickListener();

            return;
        } else if (!this._apiKey) {
            console.error('apiKey param is required');
            return;
        }

        if (user) {
            this._user = {
                dlaUserId: user.dla_user_id,
                firstName: user.name,
                lastName: user.last_name,
                email: user.email
            };

            if (user.hasOwnProperty('organizations') && user.organizations.length) {
                let organizationDataProvider = _.first(user.organizations);
                this._organization = {
                    'id': organizationDataProvider.id,
                    'title': organizationDataProvider.title,
                    'effective_type': organizationDataProvider.effective_type,
                    'status': organizationDataProvider.status,
                    'hr_nr': organizationDataProvider.hr_nr
                };
            }
        }

        this.loadAnalytics();
    },

    /**
     * !!! The method where we can implement any analytics instance for future using!!!
     * !!! All future requests will be use current implementation !!!
     * @returns {*}
     */
    loadAnalytics() {
        //request analytics library
        if (!this._isAnalyticEngineRequested) {
            var analytics = window.analytics = window.analytics || [];
            if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
                analytics.invoked = !0;
                analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];
                analytics.factory = function (e) {
                    return function () {
                        var t = Array.prototype.slice.call(arguments);
                        t.unshift(e);
                        analytics.push(t);
                        return analytics
                    }
                };
                for (var e = 0; e < analytics.methods.length; e++) {
                    var key = analytics.methods[e];
                    analytics[key] = analytics.factory(key)
                }
                analytics.load = function (key, e) {
                    var t = document.createElement("script");
                    t.type = "text/javascript";
                    t.async = !0;
                    t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
                    var n = document.getElementsByTagName("script")[0];
                    n.parentNode.insertBefore(t, n);
                    analytics._loadOptions = e
                };
                analytics._writeKey = this._apiKey;
                analytics.SNIPPET_VERSION = "4.15.2";
                analytics.load(this._apiKey);


                //identify user (it will automatically init after js loaded)
                if (this._user) {
                    analytics.identify(this._user.dlaUserId, {
                        firstName: this._user.firstName,
                        lastName: this._user.lastName,
                        email: this._user.email && this._user.email.includes('@') ? this._user.email : null
                    });

                    //identify users group (it will automatically init after js loaded)
                    if (this._organization) {
                        analytics.group(this._organization.id, {
                            'title': this._organization.title,
                            'effective_type': this._organization.effective_type == 2 ? 'Projectowner' : 'Grantmaker',
                            'status': this._organization.status,
                            'hr_nr': this._organization.hr_nr
                        });
                    }
                }
                analytics.addSourceMiddleware(function ({payload, integration, next}) {
                    payload.raw.eventCategory = payload?.obj?.properties?.category || 'N/A';
                    payload.obj.eventCategory = payload?.obj?.properties?.category || 'N/A';
                    next(payload);
                });
            }

            this._isAnalyticEngineRequested = true;
        }

        //set the library instance & handle unresolved requests
        if (!this._isAnalyticEngineSet && !Array.isArray(window.analytics)) {
            this._analyticEngine = window.analytics;
            this._isAnalyticEngineSet = true;

            //handle unresolved requests
            this._runQueue();
        } else {
            setTimeout(() => {
                this.loadAnalytics();
            }, 1000);
        }

        return this._isAnalyticEngineSet;
    },

    /**
     * Run the unresolved events
     * @private
     */
    _runQueue() {
        this._trackPageVisitListener();
        this._trackingNavLinkClickListener();

        if (this._analyticsQueue.length) {
            _.each(this._analyticsQueue, callback => {
                let method = callback.type;

                if (typeof this[method] !== 'function') {
                    console.error('Analytics "_runQueue" - wrong action call');
                    return false;
                }

                this[method]({...callback.payload});
            });
            this._analyticsQueue = [];
        }
    },

    /**
     * Listener for Tracking Page Visit
     * @private
     */
    _trackPageVisitListener() {
        if (!this._isPageTrackingEnabled) {
            return false;
        }
        if (document.location.pathname === '/') {
            if (this._user) {
                this.trackPage({'category': 'Dashboard', 'data': {path: '/dashboard'}});
            } else {
                this.trackPage({'category': 'Index', 'data': {path: '/index'}});
            }
        } else {
            this.trackPage({
                'category': this.getMetaPageCategory(),
                'name': this.getMetaPageName() || this.getMetaPageCategory()
            });
        }
    },

    /**
     * Tracking Nav Link click
     * @private
     */
    _trackingNavLinkClickListener() {
        if (!this._isNavLinkClickEnabled) {
            return false;
        }
        document.addEventListener('DOMContentLoaded', () => {
            let links = document.getElementsByClassName('trackable-link');

            this._analyticEngine.trackLink([].slice.call(links), 'Navigation Link Clicked', function (el) {
                return {
                    link: el.getAttribute('data-name'),
                    url: el.getAttribute('href')
                };
            });
        }, false);
    },

    /**
     * Enable/disable auto page tracking
     * @param state
     */
    setPageTrackingState(state = true) {
        this._isPageTrackingEnabled = state;
    },

    /**
     * Enable/disable nav links click listener
     * @param state
     */
    setNavLinkClickState(state = true) {
        this._isNavLinkClickEnabled = state;
    },

    /**
     * Track action
     * @param payload object
     */
    track(payload) {
        if (!this._isActive) {
            return;
        }

        if (!payload.hasOwnProperty('name') || !payload.name) {
            console.error('Track event "name" parameter is required');
            return;
        }


        if (this._isDebugMode) {
            console.log('---> Track event `' + payload.name + '`', payload);
            return;
        }
        if (payload.includeUser) {
            delete payload.includeUser;
            payload.user = this._user ? {
                firstName: this._user.firstName,
                lastName: this._user.lastName,
                email: this._user.email && this._user.email.includes('@') ? this._user.email : null,
                id: this._user.dlaUserId
            } : null
        }
        if (this._isAnalyticEngineSet) {
            const name = payload.name;
            delete payload.name;
            this._analyticEngine.track(name, payload.data || payload);
        } else {
            this._analyticsQueue.push({type: 'track', payload});
        }
    },

    /**
     * Track page view action
     * @param payload object
     */
    trackPage(payload = {}) {
        if (!this._isActive) {
            return;
        }

        if (this._isDebugMode) {
            console.log('---> Track page', payload);
            return;
        }

        if (this._isAnalyticEngineSet) {
            this._analyticEngine.page(payload.category || null, payload.name || null, payload.data || {});
        } else {
            this._analyticsQueue.push({type: 'trackPage', payload});
        }
    },

    /**
     * Helper - get page category
     * @param defaultValue
     * @returns {null|*}
     */
    getMetaPageCategory(defaultValue = null) {
        let pageCategory = document.querySelector('meta[property="analytics_page_category"]');
        if (pageCategory && pageCategory.content) {
            return pageCategory.content;
        } else if (defaultValue) {
            return defaultValue;
        } else {
            return null
        }
    },

    /**
     * Helper - get page name
     * @param defaultValue
     * @returns {null|*}
     */
    getMetaPageName(defaultValue = null) {
        let pageName = document.querySelector('meta[property="analytics_page_name"]');
        if (pageName && pageName.content) {
            return pageName.content;
        } else if (defaultValue) {
            return defaultValue;
        } else {
            return null
        }
    }
};
window.ss_analytics = Object.create(analyticsPrototype);
